import IStoreTreeStrategy from '../strategy.interface'

class RegularStateStrategy<T extends any> implements IStoreTreeStrategy<T> {
  private readonly initialState: T

  constructor(initialState: T) {
    this.initialState = initialState
  }

  get(_: string) {
    return this.initialState
  }

  set(_: string, __: T) {
    return
  }
}

export default RegularStateStrategy
